import './legacy/app_banner.css';



// WEBPACK FOOTER //
// ./src/bundles/app_banner/index.ts